import { Opinion } from "./opinion";
import { workClumn } from "./workClumn.js";
import { Labor } from "./labor.js";
import { civilCode } from "./civilCode.js";
import { constitution } from "./constitution.js";
import { criminal } from "./criminal.js";
import { administration } from "./administration.js";
import { punish } from "./punish.js";
import { handle } from "./handle.js";
import { regulations } from "./regulations";
import { Disobedience } from "./Disobedience.js";
import { review } from "./review.js";
import { repeat } from "./repeat.js";
import { prohibit } from "./prohibit.js";
import { huiyij } from "./huiyijin";
import { responsibility } from "./zhengzer";
export const mationData = [
  {
    type: "zhengzrew",
    render: responsibility,
  },
  {
    type: "huiyij",
    render: huiyij,
  },
  {
    type: "opinion",
    render: Opinion,
  },
  {
    type: "workClumn",
    render: workClumn,
  },
  {
    type: "labor",
    render: Labor,
  },
  {
    type: "civilCode",
    render: civilCode,
  },
  {
    type: "constitution",
    render: constitution,
  },
  {
    type: "criminal",
    render: criminal,
  },
  {
    type: "administration",
    render: administration,
  },
  {
    type: "punish",
    render: punish,
  },
  {
    type: "handle",
    render: handle,
  },
  {
    type: "regulations",
    render: regulations,
  },
  {
    type: "Disobedience",
    render: Disobedience,
  },
  {
    type: "review",
    render: review,
  },
  {
    type: "repeat",
    render: repeat,
  },
  {
    type: "prohibit",
    render: prohibit,
  },
];
